import { HttpClient } from "@/shared/lib/http-client"
import { env } from "@/config/env"

import type { AstroTab, AstroTodayResponse } from "../types"

export interface AstroTodayRequestContext {
  /** IANA timezone used to approximate the observer location (Moon rise/set). */
  timezone?: string
  lat?: number
  lon?: number
}

/**
 * Client for the application backend's Today aggregate (`/v1/astro-today`).
 * Authenticated with the caller's Firebase ID token. Returns the per-tab daily
 * payload (`content_id`, `daily_rune`, tarot card, biorhythm numbers) that the
 * client renders against its static content banks.
 */
export class AstroTodayService extends HttpClient {
  readonly isConfigured: boolean

  constructor(baseURL: string) {
    super({ baseURL })
    this.isConfigured = Boolean(baseURL)
  }

  async getToday(
    token: string,
    tabs?: AstroTab[],
    context?: AstroTodayRequestContext,
    signal?: AbortSignal,
  ): Promise<AstroTodayResponse> {
    return this.get<AstroTodayResponse>("/v1/astro-today", {
      headers: { Authorization: `Bearer ${token}` },
      signal,
      params: {
        ...(tabs?.length ? { tabs: tabs.join(",") } : {}),
        ...(context?.timezone ? { timezone: context.timezone } : {}),
        ...(context?.lat != null ? { lat: context.lat } : {}),
        ...(context?.lon != null ? { lon: context.lon } : {}),
      },
    })
  }
}

export const astroTodayService = new AstroTodayService(env.VITE_API_URL)
